var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isPopinDisplayed,
          expression: "isPopinDisplayed",
        },
        {
          name: "observe-visibility",
          rawName: "v-observe-visibility",
          value: { callback: _vm.popin_videoDisplayed_callback },
          expression: "{ callback: popin_videoDisplayed_callback }",
        },
      ],
      staticClass: "popin-modal full",
      attrs: { id: "video" },
    },
    [
      _c("div", { staticClass: "popin-container" }, [
        _c(
          "div",
          {
            staticClass: "popin-closure",
            on: { click: _vm.popin_videoClosed },
          },
          [_c("div", { staticClass: "arrow" }, [_vm._v("X")])]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "popin" }, [
          _c("div", { staticClass: "popin-content" }, [
            _c("div", { staticClass: "popin-content-container" }, [
              _c("iframe", {
                attrs: {
                  frameborder: "0",
                  allow:
                    "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                  referrerpolicy: "strict-origin-when-cross-origin",
                  allowfullscreen: "",
                  src: _vm.videoUrl,
                },
              }),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }